<template>
  <div class="homeBox">
    <div class="building">
      <!-- <el-image style="width: 100%; height:100vh" :src="url"></el-image> -->
      <el-row>
        <div class="homeBoxWenzi">
          <div>金飞鹰雪务通分销平台管理系统</div>
          <div>
            <span class="old_ban" @click="qiehuan">切换旧版</span>
            <p>/</p>
            <span @click="help">帮助</span> 
            <p>/</p>
            <span @click="about">关于</span> 
          </div>
          <div class="homeHello">
            <el-image class="urlHello" :src="urlHello"></el-image>
            <div class="tableLogin">
              <el-form :model="loginData">
                <div class="itemForm">
                  <el-form-item>
                    <el-input v-model="loginData.user" placeholder="请输入用户名"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input type="password" v-model="loginData.password" placeholder="请输入密码"></el-input>
                  </el-form-item>
                </div>
                <div class="itemDivs">
                  <div>
                    <el-input v-model="loginData.codeTu" placeholder="请输入验证码" class="formInput"></el-input>
                  </div>
                  <div>
                    <!-- <img :src="imgCodeUrl" alt="图形验证码" /> -->
                    <img class="imageText" :src="imageText" alt @click="codeFn" />
                    <!-- <el-input></el-input> -->
                    <!-- <VerificationCode :changeCode.sync="identifyCode"></VerificationCode> -->
                  </div>
                  <div>
                    <span @click="codeFn">换一换</span>
                  </div>
                </div>

                <div class="loginBtn">
                  <el-checkbox v-model="checked">记住密码</el-checkbox>
                  <el-form-item>
                    <el-button @click="loginFn">登陆</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
// import VerificationCode from "@/components/common/VerificationCode ";
import { signPost, codeGet } from "@/request/logins.js";
export default {
  components: {
    // VerificationCode
  },
  data() {
    return {
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      url: require("@/images/home/Group.png"),
      urlHello: require("@/images/home/hello.png"),
      // form绑定数据
      loginData: {
        user: "",
        password: "",
        codeTu: "",
        key: ""
      },
      // 登录传参
      loginPar: {
        username: "",
        password: "",
        key: "",
        captcha: ""
      },
      imageText: "",
      checked: ""
    };
  },
  mounted() {
    this.codeFn();
    if (window.localStorage.getItem("user")) {
      this.loginData.user = JSON.parse(
        window.localStorage.getItem("user")
      ).user;
      this.loginData.password = JSON.parse(
        window.localStorage.getItem("user")
      ).password;
    }
    if(localStorage.getItem('passSuper')){
      const Base64 = require("js-base64").Base64
      this.loginData.user = localStorage.getItem('userSuper')
      this.loginData.password = Base64.decode(localStorage.getItem('passSuper')) 
    }
  },
  methods: {
    qiehuan(){
      window.location.href = 'http://www.softykt.net/'
    },
    help(){
      window.location.href = 'http://ski.beebird.com.cn/Public/dowloadhelp/jfy.rar'
    },
    about(){
      window.open('http://www.softykt.cn/')
    },
    // // 获取验证码接口
    codeFn() {
      codeGet().then(res => {
        console.log(res);
        if (res) {
          this.loginData.key = res.data.url.key;
          this.imageText = res.data.url.img;
        }
      });
    },
    loginFn() {
      this.loginPar = {
        username: this.loginData.user,
        password: this.loginData.password,
        key: this.loginData.key,
        captcha: this.loginData.codeTu
      };
      signPost(this.loginPar).then(res => {
        if (res.data.rcode == 200) {
          if(res.data.result.permission.length==0){
              this.$message.error('该账号无权限')
              return false
          }
          this.navList = res.data.result.permission;
          localStorage.setItem("menue", JSON.stringify(this.navList));
          this.$message.success(res.data.msg);
          window.sessionStorage.setItem("Token", res.data.result.token);
          window.sessionStorage.setItem('path',this.$route.path)
          if(this.checked){
            const Base64 = require("js-base64").Base64
            let password = Base64.encode(this.loginData.password); // base64加密
            localStorage.setItem("userSuper", this.loginData.user);
            localStorage.setItem("passSuper", password);
          }else{
            localStorage.removeItem("userSuper");
            localStorage.removeItem("passSuper");
          } 
          this.$router.push("/workebench");
        } else {
          this.$message.error(res.data.msg);
          this.codeFn();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.homeBox {
  height: 100vh;
  position: relative;

  .building {
    background: url("../images/home/Group.png");
    width: 100%;
    height: 100%;
    position: fixed;
    background-size: 100% 100%;
    overflow: auto;

  }

  .homeBoxWenzi {
    width: 873.52px;
    position: absolute;
    right: -120px;
    > div:nth-child(1) {
      width: 560px;
      height: 20px;
      display: flex;
      justify-content: flex-end;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      margin-top: 47px;
    }

    > div:nth-child(2) {
      width: 560px;
      height: 20px;
      display: flex;
      justify-content: flex-end;
      color: #333333;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-top: 13px;
      margin-bottom: 100px;
      span{
        cursor: pointer;
      }
      p {
        margin: 0 5px;
      }
    }

    .homeHello {
      width: 560px;
      height: 609px;
      .tableLogin {
        padding-left: 10px;
        margin-top: 20px;

        .itemForm {
          /deep/.el-input {
            line-height: 0;
          }

          .el-form-item {
            margin-bottom: 40px;
          }

          /deep/.el-input__inner {
            width: 550px;
            height: 60px;
            background: #f7f7fa;
            border-radius: 30px;
            border: none;
          }
        }

        .itemDivs {
          display: flex;
          > div:nth-child(1) {
            /deep/.el-input__inner {
              width: 260px;
              height: 60px;
              border-radius: 30px;
              margin-right: 40px;
              background: #f7f7fa;
              border: none;
            }
          }

          > div:nth-child(2) {
            display: flex;
            align-items: center;
            // margin-right: 50px;
            // width: 162px;
            // height: 60px;
            // /deep/.el-input__inner {
            //   width: 162px;
            //   height: 60px;
            //   margin-right: 40px;
            //   background: #f7f7fa;
            //   border: none;
            // }
            .imageText {
              width: 162px;
              height: 60px;
              margin-right: 40px;
              // border: none;
            }
          }

          > div:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              cursor: pointer;
            }
          }
        }

        .loginBtn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 40px;
          .el-checkbox {
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: #333333;
          }
          .el-button {
            width: 420px;
            height: 60px;
            background: linear-gradient(95.3deg, #8fc1fa 0%, #246deb 97.25%);
            border-radius: 30px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */

            color: #ffffff;
          }
        }
      }
    }
  }
}
.itemDivs >div:nth-child(3){
    font-size: 16px;
}
.old_ban:hover{
  color: #246deb;
}
</style>
